/*
 * @@Author: zhouwei
 * @Date: 2024-08-05 09:35:17
 * @Description:
 */
import { Component } from 'react';
import Cookie from 'js-cookie';
import { okGlobal } from '@ok/blade';

import history from '_common/history';
import { messenger } from '_common/utils/Messenger';
import Storage from '_common/utils/Storage';
import { translate } from '_common/utils/language';

export interface RootContextProps {
  match?: {
    params?: Record<string, any>;
  };
}

export interface RootContextState {
  [key: string]: any;
}

export default class RootContext<
  P extends RootContextProps,
  S extends RootContextState
> extends Component<P, S> {
  w: {
    r: (msg: any) => void;
    g: (msg: any) => void;
  };

  monitor: any;

  constructor(props: P, context?: any) {
    super(props, context);

    this.state = {} as any;

    this.w = {
      r: (msg) => {
        if (msg instanceof Object || msg instanceof Array) {
          console.log(`%c${JSON.stringify(msg)}`, 'color:red');
        } else {
          console.log(`%c${msg}`, 'color:red');
        }
      },
      g: (msg) => {
        if (msg instanceof Object || msg instanceof Array) {
          console.log(`%c${JSON.stringify(msg)}`, 'color:green');
        } else {
          console.log(`%c${msg}`, 'color:green');
        }
      },
    };

    // eslint-disable-next-line new-cap
    this.monitor = new window.utils.monitor.newInstance({
      site: 'okjp',
      product: 'account',
    });
  }

  getSiteName = (): { siteName: string } => {
    return {
      siteName: okGlobal.site.siteName,
    };
  };

  getQuery = (): Record<string, string> => {
    const urlObj: Record<string, string> = {};
    const search = window.location.search;
    let str;
    if (search.includes('?')) {
      str = search.substring(search.indexOf('?') + 1);
      const arr = str.split('&');
      arr.forEach((val) => {
        const brr = val.split('=');
        urlObj[brr[0]] = brr[1];
      });
    }
    return urlObj;
  };

  getParams = (): Record<string, any> => {
    const { match } = this.props;
    return match?.params || {};
  };

  getLocale = (): string => {
    return Cookie.get('locale');
  };

  getSiteUrl = (urlObj: Record<string, any>): string | undefined => {
    const siteObj = urlObj || {};
    return siteObj[this.getLocale()] || siteObj.en_US;
  };

  setTitle = (key: string): void => {
    document.title = `${this.translate(key)} | ${okGlobal.site.seoTitle}`;
  };

  track(action: string, params: Record<string, any> = {}): void {
    this.monitor.act(action, params);
  }

  translate = (
    id: string,
    values?: Record<string, any>,
    withJSX?: boolean
  ): string => {
    return translate(id, values, withJSX);
  };

  showErrorDialog = (message: string): void => {
    messenger.postMessage('showPromptDialog', message);
  };

  showLoading = (): void => {
    messenger.postMessage('showLoading', true);
  };

  hideLoading = (): void => {
    messenger.postMessage('showLoading', false);
  };

  linkTo = (link: string, isReplace?: boolean, isOutLink?: boolean): void => {
    if (isOutLink) {
      window.location.href = link;
      return;
    }
    if (isReplace) {
      history.replace(link);
      return;
    }
    history.push(link);
  };

  isSubAccount = (): boolean => {
    return Storage.get('currentIsSub') === '1';
  };
}
